module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('select-year', {
    attrs: {
      "label": "Year"
    },
    model: {
      value: (_vm.thisYear),
      callback: function($$v) {
        _vm.thisYear = $$v
      },
      expression: "thisYear"
    }
  })], 1), _vm._v(" "), _c('sites-report', {
    attrs: {
      "selected-year": _vm.thisYear
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('sites-report', {
    attrs: {
      "selected-year": _vm.lastYear
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('sites-report', {
    attrs: {
      "selected-year": _vm.prioYear
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-chart-line"
  }), _vm._v(" Roll-Out Report")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4889a3ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sites/RollOutReport.vue
// module id = 1541
// module chunks = 0